import React from 'react';
import cx from 'classnames';
import { Divider } from '../../../Divider';
import { NameInitials } from '../../../NameInitials';
import { DataStoreProps } from '../../common/types';
import styles from '../style.module.css';
import { Description } from './Description';
import { ShopAddress } from './ShopAddress';
import { ShopContact } from './ShopContact';
import { ShopOpeningHours } from './ShopOpeningHours';
import { ShopRatings } from './ShopRatings';
import { ShopTitle } from './ShopTitle';

export const CompleteDesktop = ({
  dataStore,
  handleToggleModalComment,
  handleToggleRatingModal,
  services,
  dataValue,
}: DataStoreProps) => {
  const { urlImg, logoColor, s3, phone, address, whatsapp, name, contacts } = dataStore;
  const defaultUser = !urlImg ? { backgroundColor: logoColor } : {};
  const logoBox = cx(
    'br-100 overflow-hidden ba b--boulder flex justify-center',
    styles.logoStoreData,
  );

  const renderLogo = () => {
    const fullpath = `${s3}${urlImg}`;

    if (!urlImg) {
      return <NameInitials name={name} />;
    }

    return <img src={fullpath} alt={name} title={name} className="h-100 w-100" />;
  };

  const businessHours = services ? services.businessHours : null;

  return (
    <>
      <div className={logoBox} style={defaultUser}>
        {renderLogo()}
      </div>
      <div className="flex items-start pb12-m pb12-l">
        <div className="relative">
          <ShopTitle>{name}</ShopTitle>
          <div>
            <ShopRatings
              rate={(services && services.note) || 0}
              total={(services && services.totalRating) || 0}
              ratings={[]}
              handleToggleModalComment={handleToggleModalComment}
              handleToggleRatingModal={handleToggleRatingModal}
            />
            <Divider className="mv24" />
            <ShopContact
              phone={phone}
              whatsapp={whatsapp}
              name={name}
              dataValue={dataValue}
              contacts={contacts}
            />
            {services?.description && (
              <>
                <Divider className="mv24" />
                <Description description={services?.description} />
              </>
            )}
            <Divider className="mv24" />
            <ShopAddress address={address} showH2 dataValue={dataValue} />
            <Divider className={cx('mv24', styles.clear)} />
            {/* TODO: adicionar novamente quando corrigir horario de funcionamento */}
            {/* <ShopOpeningHours businessHours={businessHours || []} /> */}
          </div>
        </div>
      </div>
    </>
  );
};
